import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExcelSheetConfig } from 'src/app/components/models/excel-dto.model';

@Injectable({
  providedIn: 'root',
})
export class ExcelDownloadService {
  EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

  constructor(private _spinner: NgxSpinnerService) {}
  async downloadExcelFile(fileName: string, sheetsConfig: ExcelSheetConfig[]) {
    this._spinner.show();

    const workbook = new ExcelJS.Workbook();

    for (const sheetConfig of sheetsConfig) {
      const worksheet = workbook.addWorksheet(sheetConfig.sheetName);

      // Add headers
      sheetConfig.headers?.forEach((header, index) => {
        const row = worksheet?.addRow(
          header instanceof Array ? header : [header]
        );
        row.font = { bold: true }; // Make the first header row bold
      });

      // Add data rows
      sheetConfig.data?.forEach(dataRow => worksheet.addRow(dataRow));

      // Merge cells if specified
      if (sheetConfig.mergeCells) {
        sheetConfig.mergeCells?.forEach(({ cells, align }) => {
          worksheet.mergeCells(cells);
          const cell = worksheet.getCell(cells?.split(':')[0]); // Access the first cell of merged range
          if (align) cell.alignment = align;
          cell.font = { bold: true };
        });
      }

      if (sheetConfig.boldCells) {
        sheetConfig.boldCells?.forEach(cell => {
          worksheet.getCell(cell).font = { bold: true };
        });
      }

      // Adjust column widths
      if (sheetConfig.columnWidths) {
        Object.entries(sheetConfig.columnWidths).forEach(
          ([colLetter, width]) => {
            worksheet.getColumn(colLetter).width = width;
          }
        );
      } else {
        // fallback default width if not provided
        worksheet.columns?.forEach(column => (column.width = 20.5));
      }
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: this.EXCEL_TYPE });
    saveAs(blob, `${fileName}.xlsx`);
    this._spinner.hide();
  }
}
